/**
 * @file tableAnnotationsPageQuery.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 02, 2025 17:53
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    TABLE_ANNOTATIONS_PAGE_QUERY_REQUEST,
    tableAnnotationsPageQuerySuccess,
    tableAnnotationsPageQueryFailure,
} from 'src/store/actions/tableAnnotator/tableAnnotatorDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/tableAnnotator/pageQuery';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            queryObj: payload,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(tableAnnotationsPageQuerySuccess(resp.payload));

    } catch (error) {

        yield put(tableAnnotationsPageQueryFailure(error));

        handleSagaErrors(error);

    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(TABLE_ANNOTATIONS_PAGE_QUERY_REQUEST, createRequestSaga);
}
